import { render } from "./Notes.vue?vue&type=template&id=78cf6587"
import script from "./Notes.vue?vue&type=script&lang=js"
export * from "./Notes.vue?vue&type=script&lang=js"
script.render = render

export default script